module.exports = __webpack_public_path__ + "img/GHS01.fcace292.webp";